import { useMutation } from '@tanstack/react-query';
import { formatPhone } from '../utils/functions/formatPhone';
import { ContatoService } from '../service/contato';
import { useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

export type FormValues = {
  nome: string;
  mensagem: string;
  email: string | undefined;
  telefone: string | undefined;
  recaptchaToken: string;
};

const contatoService = new ContatoService();

export function useForm() {
  const formRef = useRef<HTMLFormElement>(null);
  const reCAPTCHARef = useRef<ReCAPTCHA>(null);

  const [message, setMessage] = useState<'success' | 'error' | undefined>();
  const [formError, setFormError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const mutation = useMutation({
    mutationFn: (body: FormValues) => contatoService.send(body),
    onSuccess: (res) => {
      if (res?.sucesso) {
        setMessage('success');
      } else {
        setMessage('error');
      }
    },
    onError: () => {
      setMessage('error');
    },
    onSettled: () => {
      setIsSubmitting(false);
    },
  });
 
  function reset() {
    setMessage(undefined);
    setFormError('');
    window.location.reload();
  }

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setFormError('');
    setIsSubmitting(true);

    try {
      const token = await reCAPTCHARef.current?.executeAsync();
      if (!token) throw new Error('Token inválido');
      

      const form = formRef.current;
      if (!form) return;

      const data = new FormData(form);
      const nome = data.get('nome')?.toString().trim() || '';
      const mensagem = data.get('mensagem')?.toString().trim() || '';
      const email = data.get('email')?.toString().trim();
      const telefone = data.get('telefone')?.toString().trim();

      if (!email && !telefone) {
        setFormError('Informe o e-mail ou o telefone');
        setIsSubmitting(false);
        return;
      }

      const payload: FormValues = {
        nome,
        mensagem,
        email: email || undefined,
        telefone: telefone || undefined,
        recaptchaToken: token,
      };

      mutation.mutate(payload);
    } catch (error) {
      setIsSubmitting(false);
      setMessage('error');
    }
  };

  function formatInput(e: React.ChangeEvent<HTMLInputElement>, id: string) {
    if (id === 'telefone') {
      const value = e.target.value.replace(/\D/g, '');
      const phone = formatPhone(value);
      e.target.value = phone;
    }
  }

  return {
    reset,
    formRef,
    message,
    formError,
    formatInput,
    handleSubmit,
    isSubmitting,
    setMessage,
    reCAPTCHARef,
  };
}
